import { z } from 'zod';

import { ExperienceVersion } from '../..';

export enum TranslationEntityTable {
  AddOn = 'add_on_i18n',
  CancellationPolicy = 'cancellation_policy_i18n',
  ReschedulePolicy = 'reschedule_policy_i18n',
  Category = 'category_i18n',
  CustomQuestion = 'custom_question_i18n',
  Experience = 'experience_i18n',
  Listing = 'listing_i18n',
  ListingV3 = 'listing_v3_i18n',
  ListingAddOn = 'listing_add_on_i18n',
  ListingIncluded = 'listing_included_i18n',
  Location = 'location_i18n',
  Media = 'media_i18n',
  ResourceGroup = 'resource_group_i18n',
  ResourceGroupCollection = 'resource_group_collection_i18n',
  Tax = 'tax_i18n',
  User = 'user_i18n',
  Vibe = 'vibe_i18n',
  Duration = 'duration_i18n',
}

export const TranslationSchema = z.object({
  id: z.string().nullable().optional(),
  parentId: z.string(),
  fieldName: z.string(),
  languageCode: z.string(),
  isManuallySet: z.boolean(),
  value: z.string(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  version: z.nativeEnum(ExperienceVersion).optional(),
});

export const TranslationsSchema = z.array(TranslationSchema);

export type Translation = z.infer<typeof TranslationSchema>;

export const TranslationWithIdSchema = TranslationSchema.required({ id: true });

export const TranslationsWithIdSchema = z.array(TranslationWithIdSchema);

export type TranslationWithId = z.infer<typeof TranslationWithIdSchema>;
